import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/kpi/kpiItem";

export default {
    /** 分页查询考核项 */
    queryList: (data) => axios.get({url: `${PREFIX_URI}/queryList`, data: data}),
    /** 保存考核项 */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /** 删除考核项 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
};
